// 앱 브랜드 이름 — 한 곳. 바꾸려면 아래 기본값이나 환경변수만 고치면 전체에 반영된다.
//   클라이언트(CRA): REACT_APP_BRAND_NAME / _EN / _SHORT (빌드시 주입)
//   서버(node):      BRAND_NAME / BRAND_NAME_EN / BRAND_SHORT (런타임)
//   정적 파일(public/manifest.json·index.html)은 JS 를 못 읽으므로 거기만 따로 맞춘다.
const env = (typeof process !== 'undefined' && process.env) ? process.env : {};
const pick = (...vals) => vals.find((v) => typeof v === 'string' && v.trim() !== '');

const BRAND_NAME = pick(env.REACT_APP_BRAND_NAME, env.BRAND_NAME, '스마트건강코치 V-Care');
const BRAND_NAME_EN = pick(env.REACT_APP_BRAND_NAME_EN, env.BRAND_NAME_EN, 'Smart Health Coach V-Care');
const BRAND_SHORT = pick(env.REACT_APP_BRAND_SHORT, env.BRAND_SHORT, 'V-Care');

module.exports = { BRAND_NAME, BRAND_NAME_EN, BRAND_SHORT };
